// utils/truncateWithEllipsis.js

const truncateWithEllipsis = (text, maxLength = 20) => {
  if (!text) return "";
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

export default truncateWithEllipsis;
